import { colors } from "@/styles/colors"
import { makeStyles } from "@material-ui/core"

const useStyles = makeStyles({
	unknown: {
		color: colors.gray[400]
	},
	contact: {
		flex: 1,
		"&:hover": {
			textDecoration: "underline"
		},
		color: colors.blue[700],
		cursor: "pointer",
		fontSize: "20px"
	}
})

export default useStyles
